import { apiClient } from './client';
import { ENDPOINTS } from '../constants/api';

export const expensesAPI = {
  getExpenses: async (houseId, filters = {}) => {
    const response = await apiClient.get(ENDPOINTS.EXPENSES.LIST(houseId), {
      params: filters,
    });
    return response.data.expenses || response.data;
  },

  createExpense: async (houseId, data) => {
    const response = await apiClient.post(ENDPOINTS.EXPENSES.CREATE(houseId), data);
    return response.data;
  },

  updateExpense: async (houseId, expenseId, data) => {
    const response = await apiClient.put(
      ENDPOINTS.EXPENSES.UPDATE(houseId, expenseId),
      data
    );
    return response.data;
  },

  deleteExpense: async (houseId, expenseId) => {
    await apiClient.delete(ENDPOINTS.EXPENSES.DELETE(houseId, expenseId));
  },

  calculateBalances: async (houseId, filters = {}) => {
    const response = await apiClient.get(ENDPOINTS.EXPENSES.CALCULATE(houseId), {
      params: filters,
    });
    return response.data;
  },
};
